import React from "react";

import classnames from "classnames/bind";

import styles from "./GhostButton.module.scss";

const cx = classnames.bind(styles);

function View({
    title, //
    disabled,
    onClick,
    ...attributes
}: Props) {
    function handleClick(event: React.MouseEvent<HTMLButtonElement>) {
        if (!disabled) {
            onClick(event);
        }
    }

    return (
        <button
            type="button"
            className={cx("ghost-button")}
            disabled={disabled}
            onClick={handleClick}
            {...attributes}
        >
            {title}
        </button>
    );
}

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    title: string;
    onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}
export const GhostButton = React.memo(View);
